//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {
	getDateDiff
} from 'common/js/util'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
// import agreement from '@/pages/common/agreement.vue'
const audio = uni.createInnerAudioContext()
var time;
export default {
	data() {
		return {
			list: [],
			isFixed: false,
			end: false,
			count: 0,
			agreeShow: false,
			voiceType: {
				dynamic: require('static/sound/voice.png'),
				static: require('static/sound/sound.gif')
			},
			prevIndex: 0,
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false
			}
		}
	},
	components: {
		uniLoadMore,
		// agreement
	},
	onShow() {
		this.list = []
		this.page.currentPage = 1
		this.queryData()
	},
	onPullDownRefresh() {
		this.list = []
		this.page.currentPage = 1
		this.queryData('refresh')
	},
	onReachBottom() {
		if (this.list.length < this.count) {
			this.queryData()
		}
	},
	methods: {
		queryData(status) {
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/share/queryByContation',
				data: {
					currentPage: this.page.currentPage,
					pageSize: this.page.pageSize,
					userId: this.$store.state.userInfo.memberId || '599267700576878592'
				}
			}).then(result => {
				this.list.push.apply(this.list, this.renderData(result.data))
				this.page.loading = false
				this.count = result.count
				if (this.list.length >= this.count) {
					this.end = true
				}
				this.page.currentPage += 1
				if (status === 'refresh') {
					uni.stopPullDownRefresh();
				}
			})
		},
		preview(e, i) {
			let list = e.map(res => {
				return this.$getImg(res)
			})
			uni.previewImage({
				urls: list,
				current: i
			})
		},
		renderData(data) {
			if (!(data && data.length)) {
				return []
			}
			return data.map(t => {
				return {
					...t,
					createTime: getDateDiff(t.createTime),
					voice: 'static',
					images: t.images ? t.images.split(',') : [],
					nickName: decodeURI(t.nickName),
					content: decodeURI(t.content)
				}
			})
		},
		giveLike(t, index) {
			let _this = this
			this.$ajax({
				method: 'post',
				url: t.currentUserLikesStatus === 2 ? '/weChat/userlikes/add' : '/weChat/userlikes/updateStatus',
				data: {
					userId: this.$store.state.userInfo.memberId,
					contentId: t.id,
					appId: '111',
					status: t.currentUserLikesStatus === 0 ? 1 : 0
				}
			}).then(result => {
				t.currentUserLikesStatus === 1 ? (t.userLikesCounts -= 1, t.currentUserLikesStatus = 0) : (t.userLikesCounts +=
					1, t.currentUserLikesStatus = 1)
			})
		},
		addSound() {
			uni.navigateTo({
				url: '/pages/soundWall/add'
			})
			// if(this.$isLogin()){
			// 	if(uni.getStorageSync('isAgree')){
			// 	uni.navigateTo({
			// 		url:'/pages/soundWall/add'
			// 	})
			// 	}else{
			// 		this.agreeShow=true
			// 	}
			// }
		},
		playSounds(t, index) {
			if (audio.src != this.$getImg(t.mediaUrl)) {
				this.list[this.prevIndex].voice = 'static'
				audio.src = this.$getImg(t.mediaUrl)
				this.prevIndex = index
			}
			if (t.voice == 'static') {
				t.voice = 'dynamic'
				audio.play()
				time = setTimeout(() => {
					this.list[index].voice = 'static'
				}, t.mediaLen * 1000)
			} else {
				t.voice = 'static'
				audio.pause()
			}

		},
		submit() {
			uni.setStorageSync('isAgree', true)
			this.agreeShow = false
		},
		cancel() {
			this.agreeShow = false
		},
		linkToDetail(id) {
			// if(this.$isLogin()){
			// if(!uni.getStorageSync('isAgree')){
			// 	this.agreeShow=true
			// 	return
			// }
			uni.navigateTo({
				url: '/pages/soundWall/detail?id=' + id
			})
			// }
		}
	}
}
